import React, { useState } from "react";
import { Form, FormGroup, Label, Input, Button, Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import classNames from "classnames";

import Logo from "~/assets/images/login/login-logo.svg";

import ValidationGroup, { ValidatorMark } from "~/components/validation";

import getRecaptcha from "../_services/recaptcha";
import Security     from "~/services/security";


const RequestForm = ({})=> {

  const [email   , setEmail]   = useState("");
  const [loading , setLoading] = useState(false);
  const [message , setMessage] = useState("");
  const [errors  , setErrors]  = useState({});

  const validation = ValidationGroup("ForgotPassword");

  const hasErrors = ()=> {

    const errorList = {
      ...validation("email", email)
    };
    setErrors(errorList);

    return Boolean(Object.values(errorList).length);
  }

  const submit = async (e)=> {

    e.preventDefault();
    if(hasErrors()) return;
    setLoading(true);

    const recaptcha = await getRecaptcha();
    return Security.resetPasswordRequest({email, recaptcha})
      .then(setMessage)
      .catch(setErrors)
      .finally(()=> setLoading(false));
  };

  return (
    <div className="login-card">
      <div>

        <Link to={"/login"} className="logo"> <img src={Logo} /> </Link>

        <div className="login-main">
          <Form className="theme-form text-center" onSubmit={submit}>

            <h3 className='greeting'> Reset Your Password </h3>
            { errors.generalError && <p className='text-danger'> { errors.generalError } </p> }

            {!message && <div>
                <small className='text-muted'>
                  Enter the email associated with your account and we'll
                  send an email with instructions to reset your password
                </small>
              </div>
            }

            { message && <p className='text-success'> { message } </p> }

            <FormGroup>
              <Label className="col-form-label">Email</Label>
              <Input type="email"
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                placeholder="Email"
                className={classNames({ valid: !validation("email", email), 'is-invalid': errors.email})}
              />
              <ValidatorMark val={email} name="email" validation={validation} errors={errors} />
            </FormGroup>

            <FormGroup className="m-t-30 m-b-30">
              <Button color="login" className="btn-block" disabled={loading} type='submit'>
                { loading ? <Spinner size="sm"></Spinner> : "Send" }
              </Button>
            </FormGroup>

            { message && <p> Go to <Link className="ml-2 mr-2" to="/login"> Sign In </Link> Page </p> }
          </Form>
        </div>
      </div>
    </div>
  );
};

export default RequestForm;
